import { render } from "./AverageTemperature.vue?vue&type=template&id=f7440632"
import script from "./AverageTemperature.vue?vue&type=script&lang=js"
export * from "./AverageTemperature.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__